module.exports = __webpack_public_path__ + "a78515fbd53b901c3eec53498bdf04d1.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/directory-groups/directory/remove-groups/remove-groups.html
// module id = 2078
// module chunks = 0